import { http } from './config';

const SOLUCOES_PATH = 'solucoes';

export default {
  solicitar: ({ user, tipoSolucao }) =>
    http.post(`${SOLUCOES_PATH}/solicitar`, {
      tipoSolucao,
      user: user
    })
};
